import { snowflakeIntegrationDisplayNameVar } from '@/graphql/reactiveVars';

import { ENTITY_TYPES } from '../../entities/entities.constants';
import { EntityType } from '../../entities/types/EntityType';

// because integrated asset providers can have large numbers of assets, we limit the number of assets we show in limited-space scenarios to 4
export const NUMBER_PREVIEW_ASSETS = 4;

// We don't currently allow linking insurance accounts, because integrations typically don't
// expose policy values and "insurance accounts" only have policies and no non-policy assets
export const INTEGRATION_EXCLUDED_ENTITY_TYPES: EntityType[] = [
  ENTITY_TYPES.INSURANCE_ACCOUNT,
];

export enum AssetIntegrationProviders {
  ADDEPAR = 'ADDEPAR',
  BLACK_DIAMOND = 'BLACK_DIAMOND',
  CSV_IMPORT = 'CSV_IMPORT',
  ORION = 'ORION',
  EMONEY = 'EMONEY',
  SNOWFLAKE = 'SNOWFLAKE',
}

export const ASSET_INTEGRATION_PROVIDER_DISPLAY_NAMES: Record<
  AssetIntegrationProviders,
  string
> = {
  [AssetIntegrationProviders.ADDEPAR]: 'Addepar',
  [AssetIntegrationProviders.BLACK_DIAMOND]: 'Black Diamond',
  [AssetIntegrationProviders.ORION]: 'Orion',
  // note that this is the default value, but it can be overriden in the integration_configuration for the tenant
  [AssetIntegrationProviders.CSV_IMPORT]: 'CSV Import',
  [AssetIntegrationProviders.EMONEY]: 'eMoney',
  [AssetIntegrationProviders.SNOWFLAKE]: 'Snowflake',
};

export function getIntegrationProviderDisplayName(
  provider: AssetIntegrationProviders
): string {
  if (provider === AssetIntegrationProviders.SNOWFLAKE) {
    // TenantDetailsProvider initializes this before UI consumers mount.
    // Callers do not subscribe to name changes during the session.
    return (
      snowflakeIntegrationDisplayNameVar()?.trim() ||
      ASSET_INTEGRATION_PROVIDER_DISPLAY_NAMES.SNOWFLAKE
    );
  }

  return ASSET_INTEGRATION_PROVIDER_DISPLAY_NAMES[provider];
}
